var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChooseColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.449,
    height: 33.449
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "choose-color_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "red",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "choose-color_svg__b",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "red",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "choose-color_svg__c",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2000ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0800ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "choose-color_svg__d",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2000ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "choose-color_svg__e",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2000ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ff08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "choose-color_svg__f",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2000ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67.588 -75.588)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.842,
    cy: 11.842,
    r: 11.842,
    fill: "url(#choose-color_svg__a)",
    transform: "rotate(20.97 -169.255 247.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.842,
    cy: 11.842,
    r: 11.842,
    fill: "url(#choose-color_svg__b)",
    transform: "rotate(76 -3.421 98.457)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.842,
    cy: 11.842,
    r: 11.842,
    fill: "url(#choose-color_svg__c)",
    transform: "rotate(-48 138.448 -29.308)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.842,
    cy: 11.842,
    r: 11.842,
    fill: "url(#choose-color_svg__d)",
    transform: "rotate(-100 81.84 21.673)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.842,
    cy: 11.842,
    r: 11.842,
    fill: "url(#choose-color_svg__e)",
    transform: "rotate(-148 59.617 41.685)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.842,
    cy: 11.842,
    r: 11.842,
    fill: "url(#choose-color_svg__f)",
    transform: "rotate(145 35.391 63.503)"
  }))));
}

export default SvgChooseColor;